function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import axios from 'axios';
import { BASE_URL_MAP, DEFAULT_BASE_URL } from "./config";
import { CommonResponse } from "./response";
import { CommonRequest, ExamRequest } from "./request";
var axiosInstance = axios.create({
  baseURL: BASE_URL_MAP[BUILD_ENV] || DEFAULT_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 考试Axios
var examAxiosInstance = axiosInstance;

// 标准的request，不依赖业务
axiosInstance.interceptors.request.use(CommonRequest.success, CommonRequest.error);

// 标准的response，不依赖业务
axiosInstance.interceptors.response.use(CommonResponse.success, CommonResponse.error);

// 考试Axios，定制对应的拦截器
examAxiosInstance.interceptors.request.use(ExamRequest.success, ExamRequest.error);

// TODO 用户中心/报名中心/就业中心

// 获取对应的axios实例
var getAxiosInstance = function getAxiosInstance(business_name) {
  if (business_name === 'EXAM') return examAxiosInstance;
  return axiosInstance;
};
var Http = function Http(url, method, data, config) {
  var axiosInstance = getAxiosInstance(config === null || config === void 0 ? void 0 : config.business);
  return axiosInstance.request(_objectSpread(_objectSpread({}, config), {}, _defineProperty({
    url: url,
    method: method
  }, ['get', 'GET'].includes(method) ? 'params' : 'data', data)));
};
export default Http;